import { irm_actionNotAllowedOnThisConversation } from 'owa-locstrings/lib/strings/irm_actionnotallowedonthisconversation.locstring.json';
import { itemHeaderReplyAll } from 'owa-locstrings/lib/strings/itemheaderreplyall.locstring.json';
import { itemHeaderReply } from 'owa-locstrings/lib/strings/itemheaderreply.locstring.json';
import loc, { format } from 'owa-localize';
import confirmItemActionAllowed from '../utils/confirmItemActionAllowed';
import { lazyGetLatestNonDraftItemIdFromConversation } from 'owa-mail-reading-pane-store';
import { ClientItemId } from 'owa-client-ids';
import { ComposeViewState } from 'owa-mail-compose-store';
import { lazyReplyToMessage } from 'owa-mail-compose-actions';
import * as mailModuleOrchestrator from 'owa-mail-module-orchestrator';
import { ActionSource } from 'owa-analytics-actions';
import { InstrumentationContext } from 'owa-search/lib/types/InstrumentationContext';
import IRMRestrictions from 'owa-mail-store/lib/store/schema/IRMRestrictions';
import allowResponseForSmimeConversation from 'owa-smime/lib/utils/allowResponseForSmimeConversation';

import { action } from 'satcheljs/lib/legacy';

export default action('replyToConversation')(async function replyToConversation(
    conversationId: ClientItemId,
    isReplyAll: boolean,
    actionSource: ActionSource,
    instrumentationContexts: InstrumentationContext[],
    suppressServerMarkReadOnReplyOrForward?: boolean,
    initialComposeLogTraceId?: string,
    onComposeViewStateCreated?: (newComposeViewState: ComposeViewState) => void
) {
    const getLatestNonDraftItemIdFromConversation = await lazyGetLatestNonDraftItemIdFromConversation.import();
    const referenceItemId = await getLatestNonDraftItemIdFromConversation(conversationId);
    if (referenceItemId?.Id) {
        const restrictionToConfirm = <IRMRestrictions>{
            ReplyAllAllowed: isReplyAll,
            ReplyAllowed: !isReplyAll,
        };
        const itemActionString = isReplyAll ? loc(itemHeaderReplyAll) : loc(itemHeaderReply);

        if (
            confirmItemActionAllowed(
                referenceItemId.Id,
                restrictionToConfirm,
                format(loc(irm_actionNotAllowedOnThisConversation), itemActionString)
            ) &&
            allowResponseForSmimeConversation(referenceItemId.Id, itemActionString)
        ) {
            const replyToMessage = lazyReplyToMessage.importAndExecute({
                referenceItemId: referenceItemId,
                isReplyAll: isReplyAll,
                useFullCompose: false,
                actionSource: actionSource,
                instrumentationContexts: instrumentationContexts,
                conversationId: conversationId.Id,
                initialComposeLogTraceId: initialComposeLogTraceId,
                onComposeViewStateCreated: onComposeViewStateCreated,
                suppressServerMarkReadOnReplyOrForward: suppressServerMarkReadOnReplyOrForward,
            });

            mailModuleOrchestrator.lazyOnReplyOrReplyAllOrForwardMessage.importAndExecute();
            return replyToMessage;
        }
    }
});
